<div class="h-100 overflow-hidden">
  <div class="d-flex flex-column overflow-hidden h-100">
    <form [formGroup]="providerGroupFinancialsForm">
      <div class="row mb-3">
        <div class="col-4">
          <div class="input-label">Account Credential Key</div>
          <input
            type="text"
            placeholder="Enter Account Credential Key"
            class="input"
            formControlName="accountCredentialKey"
          />
          <div class="d-flex flex-wrap">
            <radio
              checkedValue="Y"
              formControlName="allowACH"
              (click)="validateAllowingACHInputKey()"
            >
            </radio>
            <div class="input-label mt-3">Allow ACH</div>
          </div>

          <div class="input-label" id="ach-input-label">ACH Credential Key</div>
          <input
            type="text"
            placeholder="Enter ACH Credential Key"
            class="input"
            formControlName="achCredentialKey"
            id="ach-key-input"
          />
          <br />

          <div class="d-flex flex-wrap">
            <input type="checkbox" class="input" formControlName="isDev" /> In
            Testing Mode
          </div>

          <br /><br />
          <button type="button" class="button ml-auto" (click)="manageConfig()">
            Manage Configuration
          </button>
        </div>

        <div
          class="col-6"
          container="body"
          tooltipClass="tooltip-error"
          placement="bottom"
        >
          <div class="input-label">Transaction Devices</div>
          <div class="box">
            <table>
              <thead>
                <tr>
                  <th>
                    Device Name
                    <span class="dropdown-icon">&#9660;</span>
                  </th>
                  <th>
                    Device Identifier
                    <span class="dropdown-icon">&#9660;</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container
                  *ngIf="addedDevicesGrid.length > 0; else emptyState"
                >
                  <tr *ngFor="let item of addedDevicesGrid">
                    <td>{{ item.deviceName }}</td>
                    <td>{{ item.deviceIdentifier }}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>

            <ng-template #emptyState>
              <empty-state
                class="mt-auto mb-auto empty"
                title="No Devices Yet"
              ></empty-state>
            </ng-template>
          </div>
        </div>
        <div class="col-2">
          <button type="button" class="button ml-auto" (click)="openModal()">
            Add Device
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<ng-container *ngIf="modalOpen">
  <div class="overlay">
    <div class="dialog">
      <div class="dialog-title">
        <h5>Add New Transaction Device</h5>
        <button (click)="close()">&#10006;</button>
      </div>
      <form [formGroup]="deviceForm">
        <div class="form-section">
          <label class="checkbox-label">
            <input
              type="checkbox"
              formControlName="isDefault"
              class="checkbox"
            />&nbsp;&nbsp;&nbsp;&nbsp;
            <span class="checkbox-label-text">Is Default</span>
          </label>
          <br />
          <label>Device Name</label>
          <input type="text" class="input" formControlName="deviceName" />
          <br />
          <label>Device Identifier</label>
          <input type="text" class="input" formControlName="deviceIdentifier" />
        </div>
        <div class="dialog-footer">
          <div class="footer-section">
            <button
              href="javascript:void(0);"
              (click)="close()"
              class="save-button"
            >
              <h5>Cancel</h5>
            </button>
          </div>
          <div class="footer-section">
            <button type="submit" class="save-button" (click)="addDevices()">
              <h5>Save</h5>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>
